import type { ApiLanguage } from 'pages/Markets/Form/MarketForm.types'
import type { Control } from 'react-hook-form'
import type { AvailableTranslation, AvailableTranslationType } from 'types/AvailableTranslation'
import type { Market } from 'types/Market'

export type TranslationsProps = {
  market?: Market
}

export type TranslationsFormProps = {
  availableTranslations: AvailableTranslation[]
  translations: Record<string, string>
  selectedLang: ApiLanguage
}

export type TranslationsElementProps = {
  label: string
  name: string
  control: Control<AvailableTranslationType>
  type: string
  description: string
  info?: string
}

export type TranslationsGroupViewProps = {
  selectedGroup: number
  selectedMarket: string
  selectedLang: ApiLanguage
}

export enum TranslationGroup {
  MetaTags = 1,
  Headers = 2,
  StepsSection = 3,
  Banners = 4,
  Footer = 5,
  FormSteps = 6,
  BarcodeStep = 7,
  FormFields = 8,
  CustomFormFields = 9,
  FormErrors = 10,
  Modals = 11,
  StatusPages = 12,
  PhoneVerification = 13,
  Common = 14,
  Mailings = 15,
  PromoGateway = 16,
}
